import React, { useState } from "react";
import { Search, ImageOff } from "lucide-react";

const foodData = {
  A: [
    {
      name: "Aloo Gobi",
      image:
        "https://aahaaramonline.com/wp-content/uploads/2016/04/Aloo_Gobi_Cauliflower_Potato_Stir_Fry.jpg",
    },
    {
      name: "Aloo Paratha",
      image:
        "https://peekncooksa.blob.core.windows.net/index-recipe/aloo_paratha.jpg",
    },
    {
      name: "Aloo Tikki",
      image:
        "https://www.honeywhatscooking.com/wp-content/uploads/2020/10/Aloo-Tikki-Chaat61.jpg",
    },
    {
      name: "Aloo Matar",
      image:
        "https://img-cdn.publive.online/fit-in/1200x675/sanjeev-kapoor/media/media_files/2025/04/11/FOAJAR96HCTw9dqshrpG.jpg",
    },
    {
      name: "Aloo Bonda",
      image:
        "https://images.archanaskitchen.com/images/recipes/snack-recipes/indian-snack-recipes/Aloo_Bonda_Recipe_Tea_Time_Snack_Low_Fat_Healthy_1_9e7539a505.jpg",
    },
    {
      name: "Appam",
      image:
        "https://cdn.cdnparenting.com/articles/2020/04/08124906/Appam-Recipe.webp",
    },
    {
      name: "Avial",
      image: "https://i.ndtvimg.com/i/2018-02/aviyal_620x350_81517900508.jpg",
    },
    {
      name: "Aloo Poha",
      image:
        "https://www.yummytummyaarthi.com/wp-content/uploads/2011/05/1-50.jpeg",
    },
    {
      name: "Aloo Chaat",
      image:
        "https://www.greedygourmet.com/wp-content/uploads/2020/10/indianaloochaat.jpg",
    },
    {
      name: "Aloo Jeera",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKdhcGG8NAz2lIcSJwc8yj2arFcCdRvPzlgQ&s",
    },
  ],
  B: [
    {
      name: "Biryani",
      image:
        "https://static.vecteezy.com/system/resources/previews/041/888/494/large_2x/chicken-biryani-or-biriyani-served-in-plate-isolated-on-table-top-view-indian-spicy-food-photo.jpg",
    },
    {
      name: "Butter Chicken",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2X4iYz6OHQa6ny2mVol2332-S7wMZ-fh-BA&s",
    },
    {
      name: "Bhaji",
      image: "https://cookbook.pfeiffer.net.au/files/onionBhaji.jpg",
    },
    {
      name: "Bhatura",
      image:
        "https://www.vahrehvah.com/indianfood_org/wp-content/uploads/2010/11/QSvadrcuLv.gif",
    },
    {
      name: "Baingan Bharta",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTICFxhIB13YSoATP9JS1WUDDjR3-FCPZyYhQ&s",
    },
    { name: "Bhel Puri", image: "" },
    { name: "Bhindi Masala", image: "" },
    { name: "Barfi", image: "" },
    { name: "Boondi Ladoo", image: "" },
    { name: "Bread Pakora", image: "" },
  ],
  C: [
    { name: "Chicken Tikka Masala", image: "" },
    { name: "Chole Bhature", image: "" },
    { name: "Chicken 65", image: "" },
    { name: "Chana Masala", image: "" },
    { name: "Curry", image: "" },
    { name: "Chapati", image: "" },
    { name: "Chicken Korma", image: "" },
    { name: "Chicken Chettinad", image: "" },
    { name: "Coconut Chutney", image: "" },
  ],
  D: [
    { name: "Dal Makhani", image: "" },
    { name: "Dosa", image: "" },
    { name: "Dhokla", image: "" },
    { name: "Dal Tadka", image: "" },
    { name: "Dal Fry", image: "" },
    { name: "Dabeli", image: "" },
    { name: "Dum Aloo", image: "" },
    { name: "Dhansak", image: "" },
    { name: "Dahi Vada", image: "" },
    { name: "Double Ka Meetha", image: "" },
  ],
  E: [
    { name: "Egg Curry", image: "" },
    { name: "Egg Bhurji", image: "" },
  ],
  F: [
    { name: "Fish Curry", image: "" },
    { name: "Fish Fry", image: "" },
    { name: "Falooda", image: "" },
  ],
  G: [
    { name: "Gulab Jamun", image: "" },
    { name: "Gajar Ka Halwa", image: "" },
    { name: "Gobi Manchurian", image: "" },
    { name: "Golgappa (Pani Puri)", image: "" },
    { name: "Gujarati Kadhi", image: "" },
    { name: "Gatte Ki Sabzi", image: "" },
  ],
  H: [
    { name: "Hyderabadi Biryani", image: "" },
    { name: "Halwa", image: "" },
    { name: "Haleem", image: "" },
    { name: "Handi Mutton", image: "" },
  ],
  I: [
    { name: "Idli", image: "" },
    { name: "Idiyappam", image: "" },
    { name: "Iyengar Bakery Biscuits", image: "" },
  ],
  J: [
    { name: "Jalebi", image: "" },
    { name: "Jalfrezi", image: "" },
    { name: "Jeera Rice", image: "" },
  ],
  K: [
    { name: "Kadai Chicken", image: "" },
    { name: "Kadhi", image: "" },
    { name: "Kulfi", image: "" },
    { name: "Kachori", image: "" },
    { name: "Kheer", image: "" },
    { name: "Korma", image: "" },
    { name: "Kadai Paneer", image: "" },
    { name: "Khichdi", image: "" },
    { name: "Kolhapuri Chicken", image: "" },
    { name: "Kofta", image: "" },
  ],
  L: [
    { name: "Lassi", image: "" },
    { name: "Luchi", image: "" },
    { name: "Litti Chokha", image: "" },
    { name: "Lemon Rice", image: "" },
    { name: "Laal Maas", image: "" },
  ],
  M: [
    { name: "Malai Kofta", image: "" },
    { name: "Masala Dosa", image: "" },
    { name: "Mutton Rogan Josh", image: "" },
    { name: "Momos", image: "" },
    { name: "Methi Thepla", image: "" },
    { name: "Mysore Pak", image: "" },
    { name: "Misal Pav", image: "" },
    { name: "Matar Paneer", image: "" },
    { name: "Murgh Makhani", image: "" },
    { name: "Mattar Kulcha", image: "" },
  ],
  N: [
    { name: "Naan", image: "" },
    { name: "Nihari", image: "" },
    { name: "Navratan Korma", image: "" },
    { name: "Neer Dosa", image: "" },
  ],
  P: [
    { name: "Paneer Tikka", image: "" },
    { name: "Pav Bhaji", image: "" },
    { name: "Palak Paneer", image: "" },
    { name: "Poha", image: "" },
    { name: "Paratha", image: "" },
    { name: "Puri", image: "" },
    { name: "Papdi Chaat", image: "" },
    { name: "Pakora", image: "" },
    { name: "Pongal", image: "" },
    { name: "Pesarattu", image: "" },
    { name: "Punjabi Samosa", image: "" },
  ],
  Q: [
    { name: "Qeema", image: "" },
    { name: "Qorma", image: "" },
  ],
  R: [
    { name: "Rasmalai", image: "" },
    { name: "Raita", image: "" },
    { name: "Rajma", image: "" },
    { name: "Rava Dosa", image: "" },
    { name: "Roti", image: "" },
    { name: "Rogan Josh", image: "" },
    { name: "Rabri", image: "" },
    { name: "Rava Idli", image: "" },
    { name: "Rasgulla", image: "" },
  ],
  S: [
    { name: "Samosa", image: "" },
    { name: "Saag Paneer", image: "" },
    { name: "Sambar", image: "" },
    { name: "Shahi Paneer", image: "" },
    { name: "Sev Puri", image: "" },
    { name: "Shrikhand", image: "" },
    { name: "Seekh Kebab", image: "" },
    { name: "Shahi Tukda", image: "" },
    { name: "Spicy Chicken Curry", image: "" },
    { name: "Suji Halwa", image: "" },
  ],
  T: [
    { name: "Tandoori Chicken", image: "" },
    { name: "Tikka Masala", image: "" },
    { name: "Thali", image: "" },
    { name: "Tamarind Rice", image: "" },
    { name: "Tawa Pulao", image: "" },
    { name: "Tomato Rice", image: "" },
  ],
  U: [
    { name: "Upma", image: "" },
    { name: "Uttapam", image: "" },
    { name: "Undhiyu", image: "" },
    { name: "Usal Pav", image: "" },
  ],
  V: [
    { name: "Vada", image: "" },
    { name: "Vada Pav", image: "" },
    { name: "Vindaloo", image: "" },
    { name: "Vegetable Biryani", image: "" },
    { name: "Vegetable Pulao", image: "" },
    { name: "Vegetable Korma", image: "" },
  ],
  Y: [
    { name: "Yakhni", image: "" },
    { name: "Yakhni Pulao", image: "" },
  ],
  Z: [
    { name: "Zafrani Pulao", image: "" },
    { name: "Zeera Rice", image: "" },
  ],
};

const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(to bottom right, #fff7ed, #fef3c7)",
    padding: "24px",
  },
  wrapper: {
    maxWidth: "1280px",
    margin: "0 auto",
  },
  header: {
    textAlign: "center",
    marginBottom: "32px",
  },
  title: {
    fontSize: "2.25rem",
    fontWeight: "bold",
    color: "#9a3412",
    marginBottom: "8px",
  },
  subtitle: {
    color: "#ea580c",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    padding: "24px",
    marginBottom: "24px",
  },
  searchContainer: {
    position: "relative",
    marginBottom: "24px",
  },
  searchInput: {
    width: "100%",
    paddingLeft: "40px",
    paddingRight: "16px",
    paddingTop: "12px",
    paddingBottom: "12px",
    border: "2px solid #fed7aa",
    borderRadius: "8px",
    outline: "none",
    fontSize: "16px",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    top: "12px",
    color: "#9ca3af",
  },
  buttonGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "24px",
  },
  button: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  buttonActive: {
    backgroundColor: "#f97316",
    color: "white",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    transform: "scale(1.1)",
  },
  buttonAvailable: {
    backgroundColor: "#ffedd5",
    color: "#9a3412",
  },
  buttonDisabled: {
    backgroundColor: "#f3f4f6",
    color: "#9ca3af",
    cursor: "not-allowed",
  },
  resultsTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#9a3412",
    marginBottom: "16px",
  },
  foodGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: "16px",
  },
  foodItem: {
    background: "linear-gradient(to right, #fff7ed, #fef3c7)",
    borderRadius: "8px",
    border: "1px solid #fed7aa",
    transition: "all 0.2s",
    overflow: "hidden",
    cursor: "pointer",
  },
  imageContainer: {
    width: "100%",
    height: "200px",
    backgroundColor: "#f3f4f6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
  },
  foodImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  imagePlaceholder: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    color: "#9ca3af",
  },
  foodContent: {
    padding: "16px",
  },
  foodText: {
    color: "#7c2d12",
    fontWeight: "600",
    margin: 0,
    fontSize: "1rem",
  },
  emptyState: {
    textAlign: "center",
    padding: "48px 0",
    color: "#6b7280",
  },
};

export default function IndianFoodFilter() {
  const [selectedLetter, setSelectedLetter] = useState("A");
  const [searchTerm, setSearchTerm] = useState("");
  const [imageErrors, setImageErrors] = useState({});

  const getFilteredFoods = () => {
    if (searchTerm) {
      const allFoods = Object.values(foodData).flat();
      return allFoods.filter((food) =>
        food.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    return foodData[selectedLetter] || [];
  };

  const filteredFoods = getFilteredFoods();
  const availableLetters = Object.keys(foodData);

  const getButtonStyle = (letter) => {
    const baseStyle = { ...styles.button };
    if (selectedLetter === letter && !searchTerm) {
      return { ...baseStyle, ...styles.buttonActive };
    }
    if (availableLetters.includes(letter)) {
      return { ...baseStyle, ...styles.buttonAvailable };
    }
    return { ...baseStyle, ...styles.buttonDisabled };
  };

  const handleImageError = (foodName) => {
    setImageErrors((prev) => ({ ...prev, [foodName]: true }));
  };

  return (
    <div style={styles.container}>
      <div style={styles.wrapper}>
        <div style={styles.header}>
          <h1 style={styles.title}>Authentic Bharat Cuisines</h1>
          <p style={styles.subtitle}>
            Explore delicious Indian dishes alphabetically
          </p>
        </div>

        <div style={styles.card}>
          <div style={styles.searchContainer}>
            <Search style={styles.searchIcon} size={20} />
            <input
              type="text"
              placeholder="Search for a dish..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={styles.searchInput}
              onFocus={(e) => (e.target.style.borderColor = "#fb923c")}
              onBlur={(e) => (e.target.style.borderColor = "#fed7aa")}
            />
          </div>

          <div style={styles.buttonGrid}>
            {alphabet.map((letter) => (
              <button
                key={letter}
                onClick={() => {
                  setSelectedLetter(letter);
                  setSearchTerm("");
                }}
                disabled={!availableLetters.includes(letter)}
                style={getButtonStyle(letter)}
                onMouseEnter={(e) => {
                  if (availableLetters.includes(letter)) {
                    e.target.style.backgroundColor = "#fdba74";
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedLetter === letter && !searchTerm) {
                    e.target.style.backgroundColor = "#f97316";
                  } else if (availableLetters.includes(letter)) {
                    e.target.style.backgroundColor = "#ffedd5";
                  }
                }}
              >
                {letter}
              </button>
            ))}
          </div>
        </div>

        <div style={styles.card}>
          {/* <h2 style={styles.resultsTitle}>
            {searchTerm
              ? `Search Results (${filteredFoods.length})`
              : `Letter ${selectedLetter}`}
          </h2> */}

          {filteredFoods.length > 0 ? (
            <div style={styles.foodGrid}>
              {filteredFoods.map((food, index) => (
                <div
                  key={index}
                  style={styles.foodItem}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 4px 8px rgba(0,0,0,0.15)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <div style={styles.imageContainer}>
                    {food.image && !imageErrors[food.name] ? (
                      <img
                        src={food.image}
                        alt={food.name}
                        style={styles.foodImage}
                        onError={() => handleImageError(food.name)}
                      />
                    ) : (
                      <div style={styles.imagePlaceholder}>
                        <ImageOff size={48} />
                        <span style={{ fontSize: "0.875rem" }}>Image URL</span>
                      </div>
                    )}
                  </div>
                  <div style={styles.foodContent}>
                    <p style={styles.foodText}>{food.name}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={styles.emptyState}>
              <p style={{ fontSize: "1.125rem" }}>No dishes found</p>
              {searchTerm && (
                <p style={{ fontSize: "0.875rem", marginTop: "8px" }}>
                  Try searching for something else
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
